import { GET_STORIES_REQUEST,
  GET_STORIES_SUCCESS,
  GET_STORIES_FAILED,
  DELETE_STORY_REQUEST,
  DELETE_STORY_SUCCESS,
  DELETE_STORY_FAILED,
  NEW_STORY_REQUEST,
  NEW_STORY_FAILED,
  NEW_STORY_SUCCESS,
  UPDATE_STORY_REQUEST,
  UPDATE_STORY_SUCCESS,
  UPDATE_STORY_FAILED,
  STORIES_CLEAR_ERRORS,
  STORIES_PAGINATE_DATA_CHANGE,
  STORIES_ADD_ERRORS,
  STORIES_CLEAR_SECTION_ERROR_FIELD } from '../../actions/stories/stories';
import { GET_STATISTICS_BY_STORY_FAILED,
  GET_STATISTICS_BY_STORY_REQUEST,
  GET_STATISTICS_BY_STORY_SUCCESS } from "../../actions/statistics/get-story-statistics";

const initialState = {
  allStories: [],
  requestingStories: false,
  completedStories: false,
  errorInStories: null,
  deletingStoryStory: false,
  storiesPaginateData: {
    sortByIndex: 0,
    filterByIndex: 0,
    filterByCollectionIndex: 0,
    currentPage: 0,
    fileteredStoriesCount: 0,
    query: ""
  }
}

export const stories = (state = initialState, action) => {
  switch (action.type) {
    case GET_STORIES_REQUEST:
      return Object.assign({}, state, {
        requestingStories: true,
        errorInStories: null
      })
    case GET_STORIES_SUCCESS:
      return Object.assign({}, state, {
        searching: false,
        allStories: action.payload.data.payload,
        requestingStories: false,
        errorInStories: null,
      })
    case GET_STORIES_FAILED:
      return Object.assign({}, state, {
        requesting: false,
        errorInStories: action.errorInStories
      })

      // handle new story 
    case NEW_STORY_REQUEST:
      return Object.assign({}, state, {
        requestingStories: true,
      })
    case NEW_STORY_SUCCESS:
      return Object.assign({}, state, {
        allStories: [...state.allStories, {
          ...action.payload.data.payload
        }],
        requestingStories: false,
        completedStories: true,
        errorInStories: null,
      })
    case NEW_STORY_FAILED:
      return Object.assign({}, state, {
        requestingStories: false,
        completedStories: false,
        errorInStories: action.error
      })

    // handle update 
    case UPDATE_STORY_REQUEST:
      return Object.assign({}, state, {
        requestingStories: true,
        allStories: state.allStories.map(story => (action.payload._id === story._id) ? Object.assign(story, action.payload) : story)
      })
    case UPDATE_STORY_SUCCESS:
      return Object.assign({}, state, {
        allStories: state.allStories.map(story => (action.payload.data.payload._id === story._id ? action.payload.data.payload : story)),
        errorInStories: null,
        requestingStories: false
      })
    case UPDATE_STORY_FAILED:
      return Object.assign({}, state, {
        errorInStories: action.error,
        requestingStories: false
      })
    case GET_STATISTICS_BY_STORY_REQUEST:
      return Object.assign({}, state, {
        statisticsRequesting: true
      })
    case GET_STATISTICS_BY_STORY_SUCCESS:
      return Object.assign({}, state, {
        statistics: action.payload.data.payload,
        statisticsError: null,
        statisticsRequesting: true
      })
    case GET_STATISTICS_BY_STORY_FAILED:
      return Object.assign({}, state, {
        statisticsError: action.error,
        statisticsRequesting: true
      })

    case DELETE_STORY_REQUEST:
      return Object.assign({}, state, {
        requestingStories: true
      })
    case DELETE_STORY_SUCCESS:
      return Object.assign({}, state, {
        requestingStories: false,
        allStories: state.allStories.filter(story => story._id !== action.payload.data.payload._id),
        errorInStories: null,
      })
    case DELETE_STORY_FAILED:
      return Object.assign({}, state, {
        requestingStories: false,
        errorInStories: action.error
      })
    case STORIES_CLEAR_ERRORS:
      return Object.assign({}, state, {
        errorInStories: null,
        completedStories: false
      })
    case STORIES_ADD_ERRORS:
      return Object.assign({}, state, {
        errorInStories: action.payload
      })
    case STORIES_CLEAR_SECTION_ERROR_FIELD:
      const { field, sectionId } = action.payload;
      if(state.errorInStories) {
        const sectionKeys = state.errorInStories.errorKeys[sectionId];

        if(sectionKeys) {
          const errorMessage = sectionKeys[field];
          if(errorMessage) {
            state.errorInStories.splice(state.errorInStories.indexOf(errorMessage), 1);
            delete sectionKeys[field];
          }
        }

        if(!state.errorInStories.length) {
          state.errorInStories = null;
        }
      }
      return Object.assign({}, state)
    case STORIES_PAGINATE_DATA_CHANGE:
      return Object.assign({}, state, {
        storiesPaginateData: Object.assign(state.storiesPaginateData, action.payload)
      })

    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/redux/reducers/stories/stories.js